import Api from './Home.api.js';
import {
  filter as _filter,
  find as _find,
  forEach as _forEach,
  isEmpty as _isEmpty,
  groupBy as _groupBy
} from 'lodash-es';

import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

const storeList = new Api('', 'sphere');

// ! get home page config data from api
export const getHomepageConfig = createAsyncThunk('homePage/getHomepageConfig', async (props, { rejectWithValue }) => {
  try {
    const apiData = await storeList.getHomepageConfig(props);
    if (apiData && apiData?.hasError) {
      const errorObj = apiData;
      throw new Error(errorObj);
    } else {
      const { data } = apiData;
      return data.data;
    }
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const setSingleValue = createAction('homePage/getHomepageConfig');
